var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('loading')],1):_c('line-chart',{attrs:{"height":"300px","prop-map":_vm.propMap,"view-model":_vm.data,"tooltip-formater":_vm.tooltipRender,"tooltip-class":"cust-line-chart-tooltip"}})}
var staticRenderFns = []

export { render, staticRenderFns }